import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { FaPlus, FaEdit, FaSave, FaTimes } from "react-icons/fa";

export default function LinkedDoctorForm({ onSave, onCancel, editData }) {
  const initialFormData = {
    doctor_name: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (editData) {
      setFormData(editData);
      setErrors({});
    } else {
      setFormData(initialFormData);
    }
  }, [editData]);

  const handleInputChange = useCallback(
    (field, value) => {
      setFormData((prevData) => ({ ...prevData, [field]: value }));
      if (errors[field]) {
        setErrors((prevErrors) => ({ ...prevErrors, [field]: null }));
      }
    },
    [errors]
  );

  const validate = () => {
    const newErrors = {};
    if (!formData.doctor_name.trim()) {
      newErrors.doctor_name = " Name is required.";
    }

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    // Convert conversion_rate to a number before saving.
    const dataToSave = {
      ...formData,
    };
    onSave(dataToSave);
  };

  return (
    <form
      className="bg-white p-4 border rounded shadow"
      onSubmit={handleSubmit}
      noValidate
    >
      <h2 className="text-xl font-bold mb-4 flex items-center space-x-2">
        {editData ? <FaEdit /> : <FaPlus />}
        <span>{editData ? "Edit Doctor" : "Add Doctor"}</span>
      </h2>
      <div className="space-y-4">
        <div>
          <label className="block text-gray-700 mb-1" htmlFor="unit_name">
            Doctor Name<span className="text-red-500">*</span>
          </label>
          <input
            id="doctor_name"
            type="text"
            className={`w-full px-4 py-2 border rounded ${
              errors.doctor_name ? "border-red-500" : "border-gray-300"
            }`}
            value={formData.doctor_name}
            onChange={(e) => handleInputChange("doctor_name", e.target.value)}
            placeholder="Enter Doctor name"
          />
          {errors.doctor_name && (
            <p className="text-red-500 text-sm mt-1">{errors.doctor_name}</p>
          )}
        </div>
      </div>
      <div className="mt-4 flex justify-end space-x-4">
        <button
          type="button"
          className="flex items-center px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors"
          onClick={onCancel}
        >
          <FaTimes className="mr-2" /> Cancel
        </button>
        <button
          type="submit"
          className="flex items-center px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 transition-colors"
        >
          <FaSave className="mr-2" /> Save
        </button>
      </div>
    </form>
  );
}

LinkedDoctorForm.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  editData: PropTypes.shape({
    doctor_name: PropTypes.string,
  }),
};

LinkedDoctorForm.defaultProps = {
  editData: null,
};
